import {
  useGetExamResultSolutionDetailsQuery as useGetExaminationResultSolutionDetail,
  GetExamResultSolutionDetailsQuery as examResultSolutionDetailType,
} from '../../generated/graphql';

export default useGetExaminationResultSolutionDetail;
export type { examResultSolutionDetailType };
